"use client";

import type { ChatStatus } from "ai";
import { Context } from "@/components/ai-elements/context";
import { MODEL_CONTEXT_LIMITS, type ModelId } from "@/lib/ai/models";
import { type ChatTokenUsage, getTotalTokens } from "@/lib/ai/token-usage";

type Props = {
  usage?: ChatTokenUsage;
  modelId: ModelId;
  status: ChatStatus;
};

/** Shows measured consumption; context is only comparable for the measured model. */
export function TokenUsageIndicator({ usage, modelId, status }: Props) {
  if (!usage) return null;
  const isModelChanged =
    usage.modelId !== undefined && usage.modelId !== modelId;
  const maxTokens =
    usage.modelId === modelId ? MODEL_CONTEXT_LIMITS[modelId] : undefined;
  return (
    <Context
      maxTokens={maxTokens}
      usedTokens={
        usage.finalStepUsage?.inputTokens !== undefined &&
        usage.finalStepUsage.outputTokens !== undefined
          ? getTotalTokens(usage.finalStepUsage)
          : undefined
      }
      usage={usage.tokenUsage}
      isPartial={usage.isPartial}
      modelId={usage.modelId}
      isModelChanged={isModelChanged}
      isPrevious={
        usage.isPrevious || status === "submitted" || status === "streaming"
      }
    />
  );
}
